import { Button } from "@/components/ui";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/Dropdown";
import { File } from "lucide-react";
import { DownloadReport } from "./DownloadReport";

export const DownloadMultipleReports = ({
  pdfUrls,
}: {
  pdfUrls: string[];
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="link" leftIcon={File}>
          Reports
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {Array.from(pdfUrls).map((pdfUrl, index) => (
          <DropdownMenuItem key={pdfUrl}>
            <DownloadReport
              pdfUrl={pdfUrl}
              buttonText={`Report ${index + 1}`}
            />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
